import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styles from "./ProductsHead.module.css";
import { useProducts } from "../../../context/ProductsContext";
import useIsMobile from "../../../utils/isMobile";

function ProductsHead() {
  const products = useProducts();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { category } = useParams();

  const handleCategoryClick = (category) => {
    navigate(`/Products${category}`);
  };

  const findProductByName = (items, targetName) => {
    for (const item of items) {
      if (item.name === targetName) {
        return item;
      }
      if (item.childs) {
        const found = findProductByName(item.childs, targetName);
        if (found) return found;
      }
    }
    return null;
  };

  const renderChilds = (childs) => {
    return childs.map((x) => {
      return (
        <div
          className={`${styles.productsCatCont} ${
            x.name == "Products" && category == undefined
              ? styles.isActive
              : x.name == category
              ? styles.isActive
              : ""
          }`}
          key={x.id}>
          <button
            className={`${styles.productCatBtn} `}
            onClick={() =>
              handleCategoryClick(x.name === "Products" ? "" : `/${x.name}`)
            }>
            {x.title}
          </button>

          <div className={`${styles.productCatChilds}`}>
            {!x.list && renderChilds(x.childs)}
          </div>
        </div>
      );
    });
  };

  return (
    <header className={`${styles.ProductsHeadCont}`}>
      <div className={`${styles.productsHead}`}>
        {products && renderChilds(products)}
      </div>
    </header>
  );
}

export default ProductsHead;
